import { render, staticRenderFns } from "./MedicalSpecialityAlterModal.vue?vue&type=template&id=47467e7b"
import script from "./MedicalSpecialityAlterModal.vue?vue&type=script&lang=js"
export * from "./MedicalSpecialityAlterModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports